<template>
  <div class="password-gate" :class="getClasses">
    <transition name="fade">
      <form
        class="password-gate-form"
        v-if="!valid"
        @submit.prevent="onFormSubmit"
      >
        <input
          @focus="onFocus"
          @blur="onBlur"
          v-model="password"
          type="text"
          class="main-input"
          placeholder="One + One"
        />
        <span class="arrow" @click="onFormSubmit">⤶</span>
      </form>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      valid: false,
      darkMode: false,
      password: "",
    };
  },
  computed: {
    getClasses() {
      return {
        dark: this.darkMode || this.valid,
        valid: this.valid,
      };
    },
  },
  methods: {
    onFormSubmit() {
      if (this.password.toLowerCase() == "two") {
        this.valid = true;

        setTimeout(() => {
          this.$emit("success");
        }, 1000);
      }
    },
    onFocus() {
      this.darkMode = true;
    },
    onBlur() {
      if (this.password.length == 0) {
        this.darkMode = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.password-gate {
  width: 100vw;
  height: calc(var(--vh, 1vh) * 100);
  padding: 40px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--password-gate-background-color-default);
  transition: background var(--big-animations-duration);

  &.dark {
    background: var(--password-gate-background-color-focused);
  }

  &.valid {
    cursor: wait;
  }

  .password-gate-form {
    color: var(--password-gate-text-color);
    width: 100%;
    max-width: 350px;
    display: flex;

    .main-input {
      display: block;
      text-transform: capitalize;
      width: 100%;
      border: none;
      background-color: transparent;
      padding: 15px 0;
      font-size: 3em;
      letter-spacing: -1.3px;
      color: inherit;

      &:focus,
      &:active {
        outline: none;
      }
    }

    .arrow {
      flex-grow: 0;
      flex-shrink: 0;
      flex-basis: 50px;
      font-size: 3.5em;
      padding-top: 14px;
      cursor: pointer;
      font-weight: lighter;
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity var(--small-animations-duration);
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  ::placeholder {
    color: var(--password-gate-placeholder-color);
  }
  :-ms-input-placeholder {
    color: var(--password-gate-placeholder-color);
  }
  ::-ms-input-placeholder {
    color: var(--password-gate-placeholder-color);
  }
}
</style>